export default __webpack_public_path__ + "ba1cc83743b1c91e3bcdfd3b5f864e94.jpg";